import React from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import { createResource, useResource } from '@/lib/i18n'
import Link from 'next/link'
import { Action } from '@@/action_pb'
import { eventLogProducer } from '@/lib/event-logger'

const resource = createResource({
  en: {
    title: 'We have not answer your questions?',
    desc: 'We will help answer your questions',
    desc1: `Don't hesitate and let us help you`,
  },
  id: {
    title: 'Pertanyaan anda masih belum terjawab?',
    desc: 'Kami akan bantu penuhi pertanyaan Anda',
    desc1: `Jangan ragu dan biarkan kami membantu Anda`,
  },
})

const NoQuestionSubmit = () => {
  const { t } = useResource(resource)
  const eventClick = () => {
    eventLogProducer.push({
      action: Action.CONTACTUSCLICK,
    })
  }
  return (
    <SubmitStyle>
      <div className="right">
        <div className="title">{t('title')}</div>
        <div className="subtitle">{t('desc')}</div>
        <div className="subtitle">{t('desc1')}</div>
        <Button role="button" aria-disabled="false" type="submit" className="btn" onClick={eventClick}>
          <Link
            href={`https://kreditpintar.zendesk.com/hc/id-id/requests/new?ticket_form_id=360000356952`}
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            Contact us
          </Link>
        </Button>
      </div>
    </SubmitStyle>
  )
}

export default NoQuestionSubmit

const SubmitStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    .right {
      width: 272px;
      margin: 0 auto;
      .title {
        font-size: 24px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
        padding: 30px 0 20px;
      }
      .subtitle {
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #212121;
        line-height: 32px;
      }
      .btn {
        margin-top: 32px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: #1cc812;
        color: white;
        text-align: center;
        border-radius: 8px;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .right {
      padding-top: 28px;
      width: 420px;
      .title {
        font-size: 36px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 40px;
        padding: 60px 0 32px;
      }
      .subtitle {
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #212121;
        line-height: 32px;
      }
      .btn {
        margin-top: 72px;
        width: 100%;
        height: 56px;
        background-color: #1cc812;
        color: white;
        text-align: center;
        line-height: 56px;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
`
